/* Contoured Nutrition Shopify Theme v1.0 (jQuery 1.4.1 required). Copyright (c) Pixellent, LLC <http://www.pixellent.com>. */

/**
* @package Quimbee
*/
jQuery( document ).ready(function( $ ) {
	// Prepopulate any form fields with values taken from GET params
	if(self.location.search!='' && window.location.href.indexOf("refinementList") === -1) {
		var formParams = {};
		var params = self.location.search.replace(/\?/, '').split('&');
		for(var i=0; i<params.length; i++) {
			var kv = params[i].split('=');
			formParams[kv[0]] = decodeURIComponent(kv[1]);
		}
		for(var k in formParams) {
			$('form input[id='+k+']').val(formParams[k]);
		}
	}
	});
	
/*global $ */
$(document).ready(function() {

  "use strict";

  $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  //Checks if li has sub (ul) and adds class for toggle icon - just an UI

  $('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
  //Checks if drodown menu's li elements have anothere level (ul), if not the dropdown is shown as regular dropdown, not a mega menu (thanks Luka Kladaric)


     /*$(".menu > ul > li").hover(function (e) {
        if ($(window).width() > 1024) {
            $(this).children("ul").stop(true, false).fadeToggle(150);
            e.preventDefault();
        }
    });*/
  
  	var timeoutId;
  	
  	$(".menu > ul > li").hover(function () {
      if ($(window).width() > 770) {
      	var ul = $(this).find('>ul');
		if(ul.length>0){
			var hovermenuli = $(this);
			if (!timeoutId) {
				timeoutId = window.setTimeout(function () {
					timeoutId = null;
					ul.fadeIn(100);
					hovermenuli.children("a:eq(0)").addClass('li-hover');
				}, 100);
			}
		}
      }
    }, function () {
      if ($(window).width() > 770) {
        var hovermenuli = $(this);
      	var ul = $(this).find('>ul');
        if (timeoutId) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
        } else {
            ul.fadeOut(100);
            hovermenuli.children("a").removeClass('li-hover');
        }
      }
    });
  
    //If width is more than 943px dropdowns are displayed on hover

    $(".menu > ul > li").click(function () {
        if ($(window).width() <= 1024) {
            $(this).children("ul").fadeToggle(150);
        }
    });
    //If width is less or equal to 943px dropdowns are displayed on click (thanks Aman Jain from stackoverflow)

});

var pInfScrLoading = false;
var pInfScrDelay = 100;

function pInfScrExecute() {
  if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    var loadingImage;
    pInfScrNode = $('.more').last();	
    pInfScrURL = $('.more a').last().attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
        },
        success: function(data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          var filteredData = $(data).find(".collection-matrix");
          filteredData.insertBefore( $("#product-list-foot") );
          loadingImage.remove();					
          pInfScrLoading = false;
        },
        dataType: "html"
      });
    }
  }
}

function getSParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

function setSCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  var path = "path=/";
  document.cookie = cname + "=" + cvalue + "; " + expires + "; " + path;
} 

function getSCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }

  return "";
}
